<template>
  <section
    :class="{ 'grey lighten-3': !$vuetify.theme.dark, 'grey darken-4': $vuetify.theme.dark }"
    :style="{ 'min-height': 'calc(100vh - ' + $vuetify.application.top + 'px)' }"
  >
    <v-container class="text-center">
      <h2 class="display-2 font-weight-bold mb-3">{{appName.toUpperCase()}} FEATURES</h2>
      <v-responsive class="mx-auto mb-8" width="56">
        <v-divider class="mb-1"></v-divider>
        <v-divider></v-divider>
      </v-responsive>

      <v-row>
        <v-col
          v-for="({ icon, title, text, type }, i) in featuresByType(showTypes)"
          :key="i"
          cols="12"
          md="4"
        >
          <v-card
            class="py-12 px-4 fill-height"
            :class="{ 'grey lighten-5': !$vuetify.theme.dark, 'grey darken-3': $vuetify.theme.dark }"
            flat
          >
            <v-sheet
              class="is-extra pa-2"
              color="accent"
              v-if="type === 'extra'"
              title="Extra cost feature"
            >
              <v-icon large>mdi-cash-usd-outline</v-icon>
            </v-sheet>
            <v-theme-provider dark>
              <div>
                <v-avatar color="primary" size="88">
                  <v-icon large v-text="icon"></v-icon>
                </v-avatar>
              </div>
            </v-theme-provider>
            <v-card-title class="justify-center font-weight-black text-uppercase" v-text="title"></v-card-title>
            <v-card-text class="subtitle-1" v-html="buildParagraph(text)"></v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="mb-0 pb-0" v-if="isOnlyBase">
        <v-col>
          <v-btn class="mt-6" color="grey" :to="{ name: 'features' }" outlined x-large>
            <span class="grey--text text--darken-1 font-weight-bold">More Features</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  data: () => ({}),
  computed: {
    ...mapState("app", ["appName"]),
    ...mapGetters("content", ["features"]),
    isOnlyBase() {
      return this.showTypes === "base";
    },
  },
  methods: {
    buildParagraph(text) {
      let html = "";
      if (typeof text === "object") {
        text.forEach((sentence) => {
          html += `<p>${sentence}</p>`;
        });
      } else {
        html += `<p>${text}</p>`;
      }
      return html;
    },
    featuresByType(type) {
      return this.features.filter(function (feature) {
        type = typeof type === "object" ? type : [type];
        return type.indexOf(feature.type) !== -1;
      });
    },
  },
  props: ["showTypes"],
};
</script>

<style lang="sass">
.is-extra
  position: absolute
  right: 10px
  top: 10px

.v-card
  &.fill-container
    height: 100%
</style>